import { render } from "./aLink.vue?vue&type=template&id=2f4334bf"
import script from "./aLink.vue?vue&type=script&lang=js"
export * from "./aLink.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__